import { Component, Input, OnInit } from '@angular/core';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { Router, ActivatedRoute, NavigationStart } from "@angular/router";
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-list-view-rotating-asset',
  templateUrl: './list-view-rotating-asset.component.html',
  styleUrls: ['./list-view-rotating-asset.component.scss'],
  standalone: true,
  imports: [CommonModule,MatExpansionModule,MatIconModule]
})
export class ListViewRotatingAssetComponent implements OnInit {
  public monitoring_screen_endpoint = BaseUrlConstantsService.MONITORING_SENSOR_API;
  public list_view_api = BaseUrlConstantsService.ASSETS_LIST;
  @Input() allDeviceSecondArray: any[];
  @Input() extendedChildList: any[];
  listViewData: any[] = [];
  isLoading: boolean = true;

  constructor(private service: BackendApiService, public router: Router ) {

  }

  async ngOnInit(): Promise<void> {
    if (this.allDeviceSecondArray && this.allDeviceSecondArray.length) {
      const batchSize = 4;
      this.listViewData = [];
      let processedAssets = 0;
      let totalAssets = this.allDeviceSecondArray.length;
      let stopLoadingAfter = Math.min(4, totalAssets);

      for (let i = 0; i < totalAssets; i += batchSize) {
        const batch = this.allDeviceSecondArray.slice(i, i + batchSize);

        const batchPromises = batch.map(async (asset) => {
          const connectedSensors = await Promise.all(
            asset.connected_sensors.map(async (device: any) => {
              const sensorBody = await this.getDeviceSensorData(
                parseInt(device.id),
                parseInt(device.inventory_id),
                parseInt(asset.user_id)
              );
              console.log(device.asset_status)
              const sensorDataDisplay = this.getSensorDataDisplay(sensorBody);
              return {
                deviceName: device.device_name,
                serialNumber: device.motor_serial_no,
                deviceConnectivityStatus: device.asset_status === undefined ? 2 : device.asset_status,
                sensorData: sensorDataDisplay,
                allDeviceData: device,
              };
            })
          );

          processedAssets++;
          if (processedAssets === stopLoadingAfter) {
            this.isLoading = false;
          }

          return {
            assetName: asset.name || "N/A",
            applicationName: asset.application.name,
            isAssetOutForService: asset.out_of_service === "yes",
            assetOnlineStatusColor:
              asset.out_of_service === "yes"
                ? "#fcda44"
                : asset.asset_status === 0 || asset.asset_status === 2
                ? "#f3291c"
                : asset.asset_status === undefined || asset.asset_status === null
                ? "#000000"
                : "#6ce807",
            assetHealthStatusColor:
              asset.out_of_service === "yes" ? "#b8b8b8" : asset.color,
            connectedSensors: connectedSensors,
            connectedSensorsCount: connectedSensors.length,
          };
        });

        const batchResults = await Promise.all(batchPromises);
        this.listViewData.push(...batchResults);
      }
      if (totalAssets < 4) {
        this.isLoading = false;
      }
    }
  }


  public async getDeviceSensorData(assetId: number, inventoryId: number, userId: number) {
    try {
      let response = await this.service.getDataWithQuery(`${this.monitoring_screen_endpoint}${assetId}/${inventoryId}?userId=${userId}`);
      let monitoringSensorDataResponse = JSON.parse(JSON.stringify(response)).data;
      return monitoringSensorDataResponse.body;
    } catch (error) {
      console.error("Error fetching sensor data:", error);
      return null;
    }
  }

  getCellBackgroundColor(sensorBody: any) {
    const { value, rangelabel, arcDelimiters } = sensorBody;
    let baseValue = parseInt(rangelabel[0]);
    let maxValue = parseInt(rangelabel[1]);
    let arc1 = ((maxValue - baseValue) * parseInt(arcDelimiters[0])) / 100;
    let arc2 = ((maxValue - baseValue) * parseInt(arcDelimiters[1])) / 100;

    if (value > arc1 && value < arc2) return "#fcda42";
    if (value >= arc2) return "#f3291c";
    return "#74fa18";
  }


  public getSensorDataDisplay(sensorBody: any) {
    if (!sensorBody || !sensorBody.sensor) return {};

    let sensorData: any = {};

    sensorBody.sensor.forEach(item => {
      let value = parseFloat(item.value);

      switch (item.key) {
        case 'x_velocity':
          sensorData.x_velocity = sensorData.x_velocity || {};
          sensorData.x_velocity.value = value.toFixed(2);
          sensorData.x_velocity.backgroundColor = this.getCellBackgroundColor(item);
          break;
        case 'y_velocity':
          sensorData.y_velocity = sensorData.y_velocity || {};
          sensorData.y_velocity.value = value.toFixed(2);
          sensorData.y_velocity.backgroundColor = this.getCellBackgroundColor(item);
          break;
        case 'z_velocity':
          sensorData.z_velocity = sensorData.z_velocity || {};
          sensorData.z_velocity.value = value.toFixed(2);
          sensorData.z_velocity.backgroundColor = this.getCellBackgroundColor(item);
          break;
        case 'Bearing_Temperature':
          sensorData.temperature_skin = sensorData.temperature_skin || {};
          sensorData.temperature_skin.value = value.toFixed(2);
          sensorData.temperature_skin.backgroundColor = this.getCellBackgroundColor(item);
          break;
        case 'Winding_Temperature':
          sensorData.temperature_core = sensorData.temperature_core || {};
          sensorData.temperature_core.value = value.toFixed(2);
          sensorData.temperature_core.backgroundColor = this.getCellBackgroundColor(item);
          break;
        case 'audible':
          sensorData.audible = sensorData.audible || {};
          sensorData.audible.value = value.toFixed(2);
          sensorData.audible.backgroundColor = '#74fa18';
          break;
      }
    });

    if (sensorBody.ultrasoundData && sensorBody.ultrasoundData.predicted) {
      sensorData.ultrasound = sensorData.ultrasound || {};
      sensorData.ultrasound.value = parseFloat(sensorBody.ultrasoundData.predicted.toFixed(2));
      sensorData.ultrasound.backgroundColor = '#74fa18';
    }

    return sensorData;
  }

  // async getObjectForNavigation(assetInfo) {
  //   try {
  //     let tempAPIRes: any[] = [];
  //     let response = await this.service.getData(`${this.list_view_api}/v2/list/view/${assetInfo.group_id}/${assetInfo.user_id}`)
  //     .then((res) => {
  //       tempAPIRes = JSON.parse(JSON.stringify(res)).data.body;
  //       tempAPIRes.forEach((obj) => {
  //         obj.connected_sensors = assetInfo.connected_sensors;
  //       })
  //     })
  //     console.log(tempAPIRes)
  //     return tempAPIRes;
  //   } catch (error) {
  //     console.error("Error fetching sensor data:", error);
  //     return null;
  //   }
  // }

  async goToDetailScreen(assetObj: any) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "managerAssets",
        deviceId: assetObj.inventory_id,
        assetid: assetObj.id,
        assetStatus: 0,
        asset_type: assetObj.asset_type,
        macaddress: assetObj.mac_address,
        asset_master_info: JSON.stringify(assetObj),
      },
    };
    this.router.navigate(["detail-nxt"], navigationExtras);
  }


}
